import demo from './demo.json';

export default {
  demo,
};
